/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import { ScopeQuestionOptionalValue } from '../../../types/surveyScope';
import { Row, Column } from '../../tracking-list';
import { QUESTION } from '../../../constants/terminology';

export const RowEmpty = (props: { question: ScopeQuestionOptionalValue, rowIndex: number }) => {
  const { question, rowIndex } = props;
  return (
    <Row key={`${question.universalTracker.getId()}-${rowIndex}`} className={'clickable'}>
      <Column className='pl-1' stretch truncate tooltip={`${QUESTION.CAPITALIZED_SINGULAR} not in scope`}>
        {`${question.shortPrefix} ${question.name}`}
      </Column>
    </Row>
  );
}
